(function () {
	'use strict';

	function getLabel(root, key) {
		return root.getAttribute('data-label-' + key) || '';
	}

	function pauseAllVideos(root) {
		root.querySelectorAll('[data-video-ugc-video]').forEach(function (v) {
			v.pause();
		});
	}

	function pauseNonActiveVideos(swiper) {
		const root = swiper.el.closest('[data-video-ugc-slider]');
		if (!root) return;

		const activeSlide = swiper.slides[swiper.activeIndex];
		root.querySelectorAll('[data-video-ugc-video]').forEach(function (video) {
			const slide = video.closest('.swiper-slide');
			if (!slide || slide !== activeSlide) {
				video.pause();
			}
		});
	}

	function playActiveVideo(swiper) {
		const root = swiper.el.closest('[data-video-ugc-slider]');
		if (!root) return;

		pauseAllVideos(root);

		const activeSlide = swiper.slides[swiper.activeIndex];
		if (!activeSlide) return;

		const video = activeSlide.querySelector('[data-video-ugc-video]');
		if (!video) return;

		video.muted = true;
		video.play().catch(function () {});

		updateControlUi(activeSlide, root);
	}

	function updateControlUi(slide, root) {
		const video = slide.querySelector('[data-video-ugc-video]');
		const muteBtn = slide.querySelector('[data-video-ugc-mute]');
		const playBtn = slide.querySelector('[data-video-ugc-playpause]');
		const iconMuted = slide.querySelector('[data-icon-muted]');
		const iconUnmuted = slide.querySelector('[data-icon-unmuted]');
		const iconPause = slide.querySelector('[data-icon-pause]');
		const iconPlay = slide.querySelector('[data-icon-play]');

		if (!video || !muteBtn || !playBtn) return;

		if (video.muted) {
			muteBtn.setAttribute('aria-pressed', 'true');
			muteBtn.setAttribute('aria-label', getLabel(root, 'unmute'));
			if (iconMuted) iconMuted.removeAttribute('hidden');
			if (iconUnmuted) iconUnmuted.setAttribute('hidden', '');
		} else {
			muteBtn.setAttribute('aria-pressed', 'false');
			muteBtn.setAttribute('aria-label', getLabel(root, 'mute'));
			if (iconMuted) iconMuted.setAttribute('hidden', '');
			if (iconUnmuted) iconUnmuted.removeAttribute('hidden');
		}

		if (video.paused) {
			playBtn.setAttribute('aria-pressed', 'true');
			playBtn.setAttribute('aria-label', getLabel(root, 'play'));
			if (iconPause) iconPause.setAttribute('hidden', '');
			if (iconPlay) iconPlay.removeAttribute('hidden');
		} else {
			playBtn.setAttribute('aria-pressed', 'false');
			playBtn.setAttribute('aria-label', getLabel(root, 'pause'));
			if (iconPause) iconPause.removeAttribute('hidden');
			if (iconPlay) iconPlay.setAttribute('hidden', '');
		}
	}

	function bindSlideControls(root, swiper) {
		root.querySelectorAll('[data-video-ugc-slide]').forEach(function (slide) {
			const video = slide.querySelector('[data-video-ugc-video]');
			const muteBtn = slide.querySelector('[data-video-ugc-mute]');
			const playBtn = slide.querySelector('[data-video-ugc-playpause]');

			if (video && muteBtn && !muteBtn.dataset.bound) {
				muteBtn.dataset.bound = 'true';
				muteBtn.addEventListener('click', function () {
					video.muted = !video.muted;
					updateControlUi(slide, root);
				});
			}

			if (video && playBtn && !playBtn.dataset.bound) {
				playBtn.dataset.bound = 'true';
				playBtn.addEventListener('click', function () {
					if (video.paused) {
						video.play().catch(function () {});
					} else {
						video.pause();
					}
					updateControlUi(slide, root);
				});

				video.addEventListener('play', function () {
					if (!slide.classList.contains('swiper-slide-active')) {
						video.pause();
						return;
					}
					updateControlUi(slide, root);
				});
				video.addEventListener('pause', function () {
					if (slide.classList.contains('swiper-slide-active')) {
						updateControlUi(slide, root);
					}
				});
			}
		});
	}

	function initVideoUgc(root) {
		if (!root || root.dataset.videoUgcInit === 'true') return;
		const el = root.querySelector('[data-video-ugc-swiper]');
		if (!el || typeof Swiper === 'undefined') return;

		const slides = root.querySelectorAll('.swiper-slide');
		if (slides.length === 0) return;

		root.dataset.videoUgcInit = 'true';

		const enableLoop = root.getAttribute('data-enable-loop') === 'true';

		const swiper = new Swiper(el, {
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 16,
			speed: 480,
			loop: enableLoop,
			watchSlidesProgress: true,
			navigation: {
				nextEl: root.querySelector('.video-ugc-slider__nav--next'),
				prevEl: root.querySelector('.video-ugc-slider__nav--prev'),
			},
			pagination: {
				el: root.querySelector('[data-video-ugc-pagination]'),
				clickable: true,
			},
			breakpoints: {
				750: {
					spaceBetween: 20,
				},
				990: {
					spaceBetween: 24,
				},
			},
			on: {
				init: function (s) {
					bindSlideControls(root, s);
					playActiveVideo(s);
				},
				slideChange: function (s) {
					pauseNonActiveVideos(s);
				},
				slideChangeTransitionEnd: function (s) {
					playActiveVideo(s);
				},
			},
		});

		root._videoUgcSwiper = swiper;
	}

	function destroyVideoUgc(root) {
		if (!root) return;
		if (root._videoUgcSwiper) {
			root._videoUgcSwiper.destroy(true, true);
			root._videoUgcSwiper = null;
		}
		pauseAllVideos(root);
		delete root.dataset.videoUgcInit;
		root.querySelectorAll('[data-video-ugc-mute], [data-video-ugc-playpause]').forEach(function (b) {
			delete b.dataset.bound;
		});
	}

	function initAll() {
		document.querySelectorAll('[data-video-ugc-slider]').forEach(initVideoUgc);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	if (!window.__videoUgcListenersBound) {
		window.__videoUgcListenersBound = true;

		document.addEventListener('shopify:section:load', function (event) {
			const root = event.target.querySelector('[data-video-ugc-slider]');
			if (root) {
				destroyVideoUgc(root);
				initVideoUgc(root);
			}
		});

		document.addEventListener('shopify:section:unload', function (event) {
			const root = event.target.querySelector('[data-video-ugc-slider]');
			if (root) destroyVideoUgc(root);
		});
	}
})();
